import { baseMarkPattern } from './__base';
export var strike = function strike(text) {
  return baseMarkPattern(text, '-');
};